import {axiosNodeClient} from "../http";

export const storeServiceNode = {}

storeServiceNode.get = function(id) {
    let storeId = parseInt(id, 10);
    if (storeId) {
        return axiosNodeClient.get('/store/' + storeId);
    } else {
        return axiosNodeClient.get('/store');
    }
}

storeServiceNode.create = function (store) {
    return axiosNodeClient.post('/store', store);
}

storeServiceNode.update = function (store) {
    return axiosNodeClient.put('/store/' + store.id, store);
}

storeServiceNode.del = function (id) {
    return axiosNodeClient.delete('/store/' + id);
}


//region LOGO
storeServiceNode.getLogo = function(id, logo) {
    let storeId = parseInt(id, 10);
    return axiosNodeClient.get(`/image/logo/${storeId}`, {
        responseType: 'arraybuffer',
        params: {
            logo: logo
        }
    }).then(data => {
        return Buffer.from(data, 'binary').toString('base64');
    });
}

storeServiceNode.uploadLogo = function(id, file) {
    let storeId = parseInt(id, 10);
    let formData = new FormData();
    formData.append('logo', file);
    return axiosNodeClient.post(`/image/logo/${id}`, formData);
}

storeServiceNode.deleteLogo = function(id, logo) {
    let storeId = parseInt(id, 10);
    return axiosNodeClient.delete(`/image/logo/${storeId}`, {
        params: {
            logoname: logo
        }
    });
}
//endregion


//region BACKGROUND
storeServiceNode.getBackground = function(id, bg) {
    let storeId = parseInt(id, 10);
    return axiosNodeClient.get(`/image/bg/${storeId}`, {
        responseType: 'arraybuffer',
        params: {
            bg: bg
        }
    }).then(data => {
        return Buffer.from(data, 'binary').toString('base64');
    });
}

storeServiceNode.uploadBackground = function(id, file) {
    let storeId = parseInt(id, 10);
    let formData = new FormData();
    formData.append('bg', file);
    return axiosNodeClient.post(`/image/bg/${id}`, formData);
}

storeServiceNode.deleteBackground = function(id, bg) {
    let storeId = parseInt(id, 10);
    return axiosNodeClient.delete(`/image/bg/${storeId}`, {
        params: {
            bgname: bg
        }
    });
}
//endregion



//region STORE CONFIG
storeServiceNode.getStoreConfig = function (storeId) {
    return axiosNodeClient.get(`/store/${storeId}/config`);
}

storeServiceNode.updateTwilioConfig = function (storeId, data) {
    return axiosNodeClient.put(`/store/${storeId}/config/twilio`, data);
}

storeServiceNode.generateKeyWedWidget = function (storeId, data) {
    return axiosNodeClient.post(`/store/${storeId}/config/key-web-widget`, data);
}

storeServiceNode.clearKeyWedWidget = function (storeId, data) {
    return axiosNodeClient.put(`/store/${storeId}/config/key-web-widget`, data);
}
//endregion
